import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import axios from "axios";
import { toast } from "react-toastify";
import Login from "../Login";

import Header from "../Header";
import logoJMD from "../../../assets/img/logo-jmd.png";

const Carousel = () => {
	const [carousels, setCarousels] = useState([]);
	const [isLoginOpen, setIsLoginOpen] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));

	const toggleLoginPopup = () => setIsLoginOpen(!isLoginOpen);
	const closeLoginPopup = () => setIsLoginOpen(false);
	const handleLoginSuccess = () => {
		setIsLoggedIn(true);
		closeLoginPopup();
	};

	useEffect(() => {
		// Keep login state in sync
		const checkLogin = () => setIsLoggedIn(!!localStorage.getItem("token"));
		window.addEventListener("storage", checkLogin);
		return () => window.removeEventListener("storage", checkLogin);
	}, []);

	useEffect(() => {
		const fetchCarousels = async () => {
			try {
				const response = await axios.get(`/api_w/carousels`, {
					headers: { db_name: process.env.REACT_APP_DB_NAME },
				});
				setCarousels(response.data.data);
			} catch (error) {
				toast.error(
					"Error fetching carousels: " +
						(error.response?.data?.message || error.message)
				);
			}
		};
		fetchCarousels();
	}, []);

	const renderMedia = (item) => {
		if (item.type === "image") {
			return (
				<div className="w-full h-[450px] md:h-[650px] relative">
					<img
						className="w-full h-full object-cover"
						src={item?.url?.split(",")[0] || logoJMD}
						alt={item.title}
						loading="lazy"
						onError={(e) => { e.target.src = logoJMD; e.target.onerror = null; }}
					/>
					<div className="absolute inset-0 bg-black/40" />
				</div>
			);
		} else if (item.type === "video") {
			const youtubeMatch = item.url.match(
				/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/
			);
			let videoUrl = item.url;
			if (youtubeMatch) {
				videoUrl = `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1&mute=1&loop=1&playlist=${youtubeMatch[1]}`;
			}
			return (
				<div className="w-full h-[450px] md:h-[650px] relative overflow-hidden">
					<iframe
						className="w-full h-full scale-[1.5] pointer-events-none"
						src={videoUrl}
						title={item.title}
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					/>
					<div className="absolute inset-0 bg-black/40" />
				</div>
			);
		}
		return null;
	};

	return (
		<section aria-label="Hero Carousel" className="relative px-5 py-5">
			<div className="w-full mx-auto overflow-hidden rounded-[1.5rem] md:rounded-[2rem] shadow-2xl relative">
				{/* Navbar inside Carousel */}
				<Header isInsideHero={true} className="!absolute" />

				{/* Carousel */}
				<Swiper
					style={{
						"--swiper-pagination-color": "#fff",
						"--swiper-navigation-color": "#fff",
						"--swiper-navigation-size": "32px",
					}}
					modules={[Autoplay, Pagination, Navigation]}
					spaceBetween={0}
					slidesPerView={1}
					autoplay={{ delay: 5000, disableOnInteraction: true }}
					pagination={{ clickable: true }}
					navigation={{ clickable: true }}
					className="w-full rounded-[1.5rem] md:rounded-[2rem]"
				>
					{carousels.length > 0 ? (
						carousels.map((item) => (
							<SwiperSlide key={item.id} className="relative">
								{renderMedia(item)}
								<div className="absolute inset-0 flex items-center">
									<div className="px-8 md:px-16 w-full">
										<div className="max-w-3xl">
											<p className="text-white/90 text-sm md:text-4xl mb-3 tracking-tight">
												Selamat Datang kembali di
											</p>
											<h1 className="text-4xl md:text-8xl font-bold text-white tracking-tight leading-[1.1] mb-8 drop-shadow-2xl">
												Jogja Madrasah <br />
												<span className="text-green-400">Digital</span>
											</h1>
											{!isLoggedIn && (
												<button
													onClick={toggleLoginPopup}
													type="button"
													className="pointer-events-auto bg-green-700 hover:bg-green-600 text-white font-bold px-10 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105 text-base"
												>
													Masuk
												</button>
											)}
										</div>
									</div>
								</div>
							</SwiperSlide>
						))
					) : (
						<SwiperSlide className="relative">
							<div className="w-full h-[450px] md:h-[750px] bg-green-900 relative">
								<div className="absolute inset-0 flex items-center">
									<div className="px-8 md:px-16 w-full text-center md:text-left">
										<p className="text-white/90 text-sm md:text-4xl mb-3 tracking-tight">
											Selamat Datang kembali di
										</p>
										<h1 className="text-4xl md:text-8xl font-bold text-white tracking-tight leading-[1.1] mb-8 drop-shadow-2xl">
											Jogja Madrasah <br />
											<span className="text-green-400">Digital</span>
										</h1>
										<button
											onClick={toggleLoginPopup}
											type="button"
											className="pointer-events-auto bg-green-700 hover:bg-green-600 text-white font-bold px-10 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105 text-base"
										>
											Masuk
										</button>
									</div>
								</div>
							</div>
						</SwiperSlide>
					)}
				</Swiper>
			</div>

			{/* Popup Login */}
			{isLoginOpen && (
				<Login
					closePopup={closeLoginPopup}
					onLoginSuccess={handleLoginSuccess}
				/>
			)}
		</section>
	);
};

export default Carousel;
